export default __webpack_public_path__ + "static/media/smedetoften-property-02.f1c01a64.jpg";